interface Props {
  isRTL: boolean;
}

const SvgCrumbSubPath: React.FC<Props> = ({ isRTL }) => {
  return (
    <svg
      style={{ transform: isRTL ? "scaleX(-1)" : "", margin: "0 4px" }}
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9640_41476)">
        <path
          d="M3.99609 2.09609C3.91652 2.09611 3.83876 2.11986 3.77275 2.16431C3.70675 2.20876 3.6555 2.27188 3.62556 2.3456C3.59562 2.41933 3.58834 2.5003 3.60466 2.57819C3.62098 2.65607 3.66016 2.72731 3.71718 2.78281L7.43437 6.5L3.71718 10.2172C3.67879 10.254 3.64815 10.2982 3.62703 10.347C3.60592 10.3959 3.59476 10.4485 3.59422 10.5017C3.59368 10.5549 3.60376 10.6077 3.62388 10.657C3.64399 10.7062 3.67374 10.751 3.71137 10.7886C3.749 10.8263 3.79376 10.856 3.84303 10.8761C3.89231 10.8962 3.94509 10.9063 3.99831 10.9058C4.05153 10.9052 4.1041 10.8941 4.15295 10.873C4.2018 10.8518 4.24595 10.8212 4.28281 10.7828L8.28281 6.78281C8.3578 6.70779 8.39992 6.60607 8.39992 6.5C8.39992 6.39393 8.3578 6.2922 8.28281 6.21719L4.28281 2.21719C4.24553 2.17887 4.20096 2.14841 4.15171 2.12761C4.10246 2.10681 4.04955 2.0961 3.99609 2.09609Z"
          className="fill-gray2"
        />
      </g>
      <defs>
        <clipPath id="clip0_9640_41476">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgCrumbSubPath;
